import React, { ReactNode, useRef, useEffect, useState } from "react";
import usePosition from "../../Hooks/usePosition";
import styled from "styled-components";
import { useResizeDetector } from "react-resize-detector";

interface StyledExpandableSectionContainerProps {
	transitionTime: number;
}
const StyledExpandableSectionContainer = styled.div<StyledExpandableSectionContainerProps>`
	transition: all ease-in-out ${(props) => props.transitionTime}s;
	background: transparent;
	width: 100%;
	max-height: 0;
	&.mask {
		overflow: auto;
	}
`;

export interface ExpandableSectionProps {
	children: ReactNode;
	className?: string;
	expand?: boolean;
	transitionTime?: number;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
	children,
	className,
	expand = false,
	transitionTime = 1,
}) => {
	const expandableContainer: any = useRef(null);

	const [hideContents, setHideContents] = useState(true);
	const [displayChildren, setDisplayChildren] = useState(false);
	const [overflowHidden, setOverflowHidden] = useState(true);

	const { width, height, ref: expandableContent } = useResizeDetector();

	useEffect(() => {
		const timeout = expand
			? setTimeout(() => {
					setHideContents(false);
			  }, transitionTime * 1000)
			: setTimeout(() => {
					setHideContents(true);
			  }, 1);
		const displayTimeout = expand
			? setTimeout(() => {
					setDisplayChildren(true);
			  }, 1)
			: setTimeout(() => {
					setDisplayChildren(false);
			  }, transitionTime * 1000);
		return () => {
			clearTimeout(timeout);
			clearTimeout(displayTimeout);
		};
	}, [expand]);

	useEffect(() => {
		if (height) {
			setOverflowHidden(true);
			setTimeout(() => {
				setOverflowHidden(false);
			}, 700);
		}
	}, [height]);

	return (
		<StyledExpandableSectionContainer
			style={{ maxHeight: expand && height ? height + 20 : 0 }}
			className={`expandable-container ${expand ? "expand" : ""} ${className} ${hideContents ? "mask" : ""} ${
				overflowHidden ? "overflow-hidden" : ""
			}`}
			ref={expandableContainer}
			aria-hidden={expand ? undefined : "true"}
			transitionTime={transitionTime}
		>
			<div
				className={`expandable-inner-container`}
				style={{ display: displayChildren ? undefined : "none" }}
				ref={expandableContent}
			>
				{children}
			</div>
		</StyledExpandableSectionContainer>
	);
};

export default ExpandableSection;
